export default {
  en: {
    pageTitle: 'Discovery Seed',
    boxTitle: '(Optional) Provide starting points for network discovery',
    help: (
      <blockquote>
        <p>
          A discovery seed is a device from which IP Fabric begins the
          auto-discovery process. These IPs can be device management IP
          addresses or networks.
        </p>
        <p>
          <strong>
            If no seed information is entered, the discovery will begin from the
            IP Fabric appliance default gateway.
          </strong>
        </p>
        <p>
          Discovery seed settings do not include or exclude any networks from
          discovery.
        </p>
      </blockquote>
    ),
    ipList: {
      heading:
        'Discovery will use this list of ip addresses as a starting point',
    },
    overlay: {
      heading: 'Are you sure, delete IP {ip}?',
      clearHeading: 'Are you sure delete all IPs?',
      btnConfirm: 'Delete',
      btnCancel: 'Cancel',
    },
    confirmDeleteAll: {
      header: 'All entries will be deleted',
      subHeader: 'Do you really want to delete all entries?',
      btnConfirm: 'Delete',
      btnSecondaryConfirm: 'Cancel',
    },
  },
};
